import { render, staticRenderFns } from "./ImportExportContainer.vue?vue&type=template&id=1d1ece8a"
import script from "./ImportExportContainer.vue?vue&type=script&lang=js"
export * from "./ImportExportContainer.vue?vue&type=script&lang=js"
import style0 from "./ImportExportContainer.vue?vue&type=style&index=0&id=1d1ece8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports